import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap';
import {Button, Form, Input, Modal, notification, Spin, Table} from 'antd';
import HelperGeneral from '../../../helpers/HelperGeneral';
import moment from 'moment';
import Api from '../../../services/Api';
import {setGlobalSpinner} from '../../../services/redux/actions/GeneralAction';
import UserInfo from '../../auth/UserInfo';
import SalesChart from '../../partials/SalesChart';
import _ from 'lodash';
import {trans} from '../../../helpers/HelperGlobal';
import MaskedInput from 'antd-mask-input';
import Countdown, {zeroPad} from 'react-countdown';
import {QrcodeOutlined} from '@ant-design/icons';
import helperGeneral from "../../../helpers/HelperGeneral";

class CampaignDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            info: {},
            salesDateBetween: 1,
            salesInfo: [],
            salesLoading: false,
            campaign_data: [],
            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
            },
            modalOpen: false,
            userOtpData: {},
            step: 1,
            productListLoading: false,
            productList: [],
            scanIndex: false,
            codeList: [],
            date: null,
        };

        this.campaign_history_column = [
            {
                title: 'İşlem Tarihi',
                dataIndex: 'date',
                sorter: false,
                width: 180,
                render: (name, record) => moment(record?.transactionDate).format('DD.MM.YYYY HH:mm'),
            },
            {
                title: 'Ürün adı',
                dataIndex: 'product_name',
                render: (name, record) => record?.productName ?? '-',
            },
            {
                title: 'Barkod No',
                dataIndex: 'barcode',
                render: (name, record) => record?.barcodeNo ?? '-',
                width: 200,
            },
            /*{
                title: 'Lokasyon',
                dataIndex: 'location',
                width: 180,
                render: (name, record) => record?.location,
            },*/
            {
                title: 'Uygulanan İndirim',
                dataIndex: 'point',
                width: 200,
                render: (name, record) => '+ ' + record?.earnedPoints ?? '-',
            },
        ];

        this.formRef = React.createRef();
        this.qrcodeArea = React.createRef();
    }

    componentDidMount() {
        const campaign_id = this.props?.match?.params?.campaign_id;

        if (!campaign_id) {
            HelperGeneral.pageChange(this, '/home');
            return null;
        }

        window.scroll(0, 0);

        this.getCampaign(campaign_id);
        this.getCampaignSalesChart(1);

        new Event('qrCodeSend', {
            bubbles: true,
            cancelable: true,
            composed: false,
        });

        window.addEventListener('qrCodeSend', (e) => {
            const {scanIndex} = this.state;
            let codeList = this.state.codeList;
            codeList[scanIndex] = e?.detail?.code;
            this.setState({
                codeList,
            }, () => {
                this.qrcodeArea.current.scrollIntoView();
            });
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const campaign_id = this.props?.match?.params?.campaign_id;
        if (prevProps?.match?.params?.campaign_id !== campaign_id) {
            this.getCampaign(campaign_id);
        }
    }

    qrScanner = (scanIndex) => {
        this.setState({scanIndex}, () => {
            window.isNativeApp = true;
            window.ReactNativeWebView.postMessage(JSON.stringify({scanner: true}));
            return true;
        });
    };

    handleTableChange = (newPagination) => {
        this.setState({
            pagination: {
                ...this.state.pagination,
                current: newPagination.current,
                pageSize: newPagination.pageSize,
            }
        });
    };

    getCampaignSalesChart(dateType) {
        const campaign_id = this.props?.match?.params?.campaign_id;
        const user = UserInfo.info();
        const accountId = user?.pharmacyId;
        this.setState({salesLoading: true, salesInfo: []}, () => {
            Api.getCampaignSalesChart(campaign_id, accountId, dateType).then((e) => {
                this.setState({
                    salesLoading: false,
                    salesInfo: e?.data?.result
                });
            }).catch((e) => this.setState({salesLoading: false}, () => HelperGeneral.alert(e)));
        });
    }

    salesDateBetween(dateType) {
        this.setState({salesDateBetween: dateType}, () => this.getCampaignSalesChart(dateType));
    }

    getCampaign(campaign_id) {
        setGlobalSpinner(true);
        const user = UserInfo.info();
        const accountId = user?.pharmacyId;

        this.setState({loading: true}, () => {
            Api.getCampaignDetail(accountId, campaign_id).then((e) => {
                if (!e.data?.result || e.data?.result?.length < 1) {
                    setGlobalSpinner(false);
                    HelperGeneral.alert(e);
                    HelperGeneral.pageChange(this, '/kampanyalar/guncel-kampanyalar');
                } else {
                    this.setState({
                        loading: false,
                        info: e.data?.result,
                        campaign_data: e.data?.result?.transactionHistories,
                        productList: e.data?.result?.products,
                    }, () => {
                        setGlobalSpinner(false);
                        this.setState({
                            productListLoading: true,
                        });
                    });
                }
            }).catch((e) => {
                setGlobalSpinner(false);
                HelperGeneral.alert(e);
                HelperGeneral.pageChange(this, '/kampanyalar/guncel-kampanyalar');
            })
        });
    }

    onFinishCampaingForm = (values) => {
        const {info, modalOpen, step, userOtpData} = this.state;
        const campaign_id = this.props?.match?.params?.campaign_id;

        if (step === 1) {
            setGlobalSpinner(true)
            if (info?.isVerify) {
                this.setState({
                    step: 3,
                }, () => {
                    setGlobalSpinner(false)
                })
            } else {
                Api.createContactOtp(HelperGeneral.clearPhoneNumber(values?.customerPhoneNumber), 3, campaign_id).then(r => {
                    userOtpData.customerPhoneNumber = HelperGeneral.clearPhoneNumber(values?.customerPhoneNumber);
                    userOtpData.expiresIn = r.data?.result?.expiresIn;
                    this.setState({
                        step: 2,
                        userOtpData: userOtpData,
                        modalOpen: true,
                        date: Date.now() + (r?.data?.result?.expiresIn * 1000)
                    }, () => {
                        setGlobalSpinner(false)
                    })
                }).catch((e) => {
                    setGlobalSpinner(false)
                    HelperGeneral.alert(e)
                })
            }

        } else if (step === 2) {
            setGlobalSpinner(true)
            Api.verifyOtp(userOtpData?.customerPhoneNumber, values?.code).then(r => {
                this.setState({
                    step: 3,
                    modalOpen: false
                }, () => {
                    setGlobalSpinner(false)
                    notification['success']({
                        message: 'Başarılı!',
                        description: 'Telefon numarası doğrulandı. Kampanya katılımına devam edebilirsiniz.',
                    });
                })
            }).catch((e) => {
                setGlobalSpinner(false)
                HelperGeneral.alert(e)
            })
        } else if (step === 3) {
            const user = UserInfo.info();
            setGlobalSpinner(true)
            let data = {
                campaignId: info?.id,
                pharmacyId: user?.pharmacyId,
                productsCode: [],
                giftsCode: [],
                customerPhoneNumber: HelperGeneral.clearPhoneNumber(values?.customerPhoneNumber)
            };
            Object.keys(values)?.map((obj, key) => {
                if (typeof values[obj].productsCode !== 'undefined') data?.productsCode.push(values[obj].productsCode)
                if (typeof values[obj].giftsCode !== 'undefined') data?.giftsCode.push(values[obj].giftsCode)
                return obj;
            }, {})
            Api.campaignUseForm(data).then((e) => {
                setGlobalSpinner(false);
                this.setState({step: 1});
                this.formRef?.current?.resetFields();
                HelperGeneral.alert("Kampanya katılımınız başarıyla sağlanmıştır.", "success");
                this.getCampaign(campaign_id);
            }).catch(e => {
                HelperGeneral.alert(e)
                setGlobalSpinner(false);
            })
        }
    }

    render() {
        const user = UserInfo.info();
        const {
            salesDateBetween,
            salesInfo,
            salesLoading,
            campaign_data,
            pagination,
            loading,
            info,
            modalOpen,
            userOtpData,
            step,
            productListLoading,
            productList,
            date
        } = this.state;
        let help = null;

        return (
            <div className={'my-account campaign campaign-detail mt-2 mt-sm-5 pb-0 pb-sm-4 min-height-container'}>
                <Container>
                    <Row>
                        <Col xs={12}>
                            <h4>Kampanyalar</h4>
                            <Breadcrumb>
                                <Breadcrumb.Item linkAs={Link} linkProps={{to: '/home'}}>Anasayfa</Breadcrumb.Item>
                                <Breadcrumb.Item linkAs={Link} linkProps={{to: '/kampanyalar/guncel-kampanyalar'}}>Kampanyalar</Breadcrumb.Item>
                                <Breadcrumb.Item active>{info?.name}</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6} className={'mt-2 mt-sm-4'}>
                            <Spin spinning={loading}>
                                <Row>
                                    {
                                        info?.campaignType === 1 && ( //aktif kampanyalarda gösteriliyor  && info?.isVerify === true
                                            <Col xs={12} className={"mb-2"}>
                                                <div className={'box m-0'}>
                                                    <Row>
                                                        <h4>Kampanyada Katılımını Doğrula</h4>
                                                        <hr style={{marginLeft: '12px', width: '85%'}}/>
                                                        {
                                                            step === 3 ? (
                                                                <h6>Ürün kodlarını aşağıdaki alanlara giriniz.</h6>
                                                            ) : (
                                                                <h6>Tüketiciye ait telefon numarasını giriniz</h6>
                                                            )
                                                        }
                                                        <div ref={this.qrcodeArea}>
                                                            <Form
                                                                className={'mt-2'}
                                                                layout={'vertical'}
                                                                initialValues={{layout: ''}}
                                                                ref={this.formRef}
                                                                onFinish={(e) => {
                                                                    return this.onFinishCampaingForm(e);
                                                                }}
                                                            >
                                                                <Row>
                                                                    {
                                                                        [1, 2, 3].includes(step) && (
                                                                            <Col xs={12}>
                                                                                <Form.Item
                                                                                    name={'customerPhoneNumber'}
                                                                                    label="Telefon Numarası"
                                                                                    rules={[
                                                                                        () => ({
                                                                                            validator(_, value) {
                                                                                                if (info?.requiredPhoneNumber) {
                                                                                                    if (!info?.isVerify) {
                                                                                                        const v = HelperGeneral.telephoneClear(value);
                                                                                                        if (v?.length === 12) {
                                                                                                            return Promise.resolve();
                                                                                                        }
                                                                                                        return Promise.reject(new Error(trans('t10')));
                                                                                                    } else {
                                                                                                        if (value) {
                                                                                                            return Promise.resolve();
                                                                                                        }
                                                                                                        return Promise.reject(new Error(trans('t10')));
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                        })]}
                                                                                    help={help}
                                                                                >
                                                                                    <MaskedInput
                                                                                        mask={'(\\+90)111-111-11-11'}
                                                                                        autoComplete={'new-password'}
                                                                                        disabled={step === 3}
                                                                                    />
                                                                                </Form.Item>
                                                                            </Col>
                                                                        )
                                                                    }
                                                                    {
                                                                        step === 3 && (
                                                                            <>
                                                                                {
                                                                                    _.times(info?.productCodeCount, (i) => (
                                                                                        <Col
                                                                                            xs={12}
                                                                                            key={i}
                                                                                            style={{position: 'relative'}}
                                                                                        >
                                                                                            <Form.Item
                                                                                                label={'Satılan Ürün ' + (i + 1)}
                                                                                                name={[i, 'productsCode']}
                                                                                                rules={[
                                                                                                    {
                                                                                                        required: (info?.requiredCodeCount > i),
                                                                                                    },
                                                                                                ]}
                                                                                            >
                                                                                                <Input
                                                                                                    onChange={(e) => {
                                                                                                        let codeList = this.state.codeList;
                                                                                                        codeList[i] = e.target.value;
                                                                                                        this.setState({
                                                                                                            codeList,
                                                                                                        });
                                                                                                    }}
                                                                                                    value={this.state.codeList[i] ?? ''}
                                                                                                />
                                                                                            </Form.Item>
                                                                                            {
                                                                                                (navigator.userAgent === 'inntheboxMobileSP') && (
                                                                                                    <div className={'qr-area'}>
                                                                                                        <QrcodeOutlined
                                                                                                            style={{fontSize: '20px'}}
                                                                                                            onClick={() => this.qrScanner(i)}/>
                                                                                                    </div>
                                                                                                )
                                                                                            }
                                                                                        </Col>
                                                                                    ))
                                                                                }

                                                                                {
                                                                                    _.times(info?.giftCodeCount, (i2) => (
                                                                                        <Col xs={12} key={i2}>
                                                                                            <Form.Item
                                                                                                label={'Hediye Verilen Ürün ' + (i2 > 0 ? (i2 + 1) : '')}
                                                                                                name={[i2, 'giftsCode']}
                                                                                                rules={[
                                                                                                    {
                                                                                                        required: true,
                                                                                                    },
                                                                                                ]}
                                                                                            >
                                                                                                <Input/>
                                                                                            </Form.Item>
                                                                                        </Col>
                                                                                    ))
                                                                                }
                                                                            </>
                                                                        )
                                                                    }
                                                                    <Col xs={8} md={6} className={'mx-auto'}>
                                                                        <Form.Item className={'m-0'}>
                                                                            <Button
                                                                                type="primary"
                                                                                className={'btn text-white btn-primary w-100'}
                                                                                style={{
                                                                                    border: 'none',
                                                                                    borderRadius: 3,
                                                                                    height: 46,
                                                                                }}
                                                                                htmlType={'submit'}
                                                                            >
                                                                                {(!info?.isVerify && step === 1) ? 'Devam Et' : [1, 2].includes(step) ? 'SMS Gönder' : 'Katıl'}
                                                                            </Button>
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row>
                                                            </Form>
                                                        </div>
                                                    </Row>
                                                </div>
                                            </Col>
                                        )
                                    }

                                    <Col xs={12}>
                                        <Spin spinning={salesLoading}>
                                            <div className={'box report report-2'}>
                                                <div className={'header'}>
                                                    <Row>
                                                        <Col>
                                                            <h4>Satış grafiğiniz</h4>
                                                        </Col>
                                                        <Col>
                                                            <div className={'filter-area'}>
                                                                <div
                                                                    className={salesDateBetween === 1 ? 'active' : ''}
                                                                    onClick={() => this.salesDateBetween(1)}
                                                                >
                                                                    GÜNLÜK
                                                                </div>
                                                                <div
                                                                    className={salesDateBetween === 2 ? 'active' : ''}
                                                                    onClick={() => this.salesDateBetween(2)}
                                                                >
                                                                    HAFTALIK
                                                                </div>
                                                                <div
                                                                    style={{width: 170}}
                                                                    className={salesDateBetween === 3 ? 'active' : ''}
                                                                    onClick={() => this.salesDateBetween(3)}
                                                                >
                                                                    Tüm Kampanya Süresi
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className={'main'}>
                                                    <SalesChart
                                                        data={salesInfo}
                                                        salesDateBetween={salesDateBetween}
                                                    />
                                                </div>
                                            </div>
                                        </Spin>
                                    </Col>
                                </Row>
                            </Spin>
                        </Col>
                        <Col xs={12} lg={6} className={'mt-4'}>
                            <div className={'box m-0 h-100'}>
                                <Row className={"h-100"}>
                                    <Col xs={12} className={"d-flex flex-column campaign-detail-stats-col"}>
                                        <Row>
                                            <Col xs={12}>
                                                <h4>Kampanya Detaylarınız</h4>
                                                <hr/>
                                                <Row className={'mt-4 mb-4'}>
                                                    <Col xs={12} lg={5} className={'title d-flex align-items-center justify-content-start'}>
                                                        Kampanya Tarihleri
                                                    </Col>
                                                    <Col xs={12} lg={7} className={'data d-flex align-items-center justify-content-end'}>
                                                        <h6>{moment(info?.startDate).format('DD MMMM')} - {moment(info?.endDate).format('DD MMMM YYYY')}</h6>
                                                    </Col>
                                                </Row>
                                                <Row className={'mt-4 mb-4'}>
                                                    <Col xs={12} lg={5} className={'title d-flex align-items-center justify-content-start'}>
                                                        Toplam Katılım Sayısı
                                                    </Col>
                                                    <Col xs={12} lg={7} className={'data d-flex align-items-center justify-content-end'}>
                                                        <h6>{info?.totalSellProducts} Adet</h6>
                                                    </Col>
                                                </Row>
                                                <Row className={'mt-4 mb-4'}>
                                                    <Col xs={12} lg={5} className={'title d-flex align-items-center justify-content-start'}>
                                                        Toplam Katılım Hakkı
                                                    </Col>
                                                    <Col xs={12} lg={7} className={'data d-flex align-items-center justify-content-end'}>
                                                        <h6>{info?.productsToSold} Adet</h6>
                                                    </Col>
                                                </Row>
                                                <Row className={'mt-4 mb-4'}>
                                                    <Col xs={12} lg={5} className={'title d-flex align-items-center justify-content-start'}>
                                                        Gerçekleşme Oranı
                                                    </Col>
                                                    <Col xs={12} lg={7} className={'data d-flex align-items-center justify-content-end'}>
                                                        <h6>{info?.realizationRate}%</h6>
                                                    </Col>
                                                </Row>
                                                {/*<Row className={'mt-4 mb-4'}>*/}
                                                {/*    <Col xs={12} lg={5} className={'title d-flex align-items-center justify-content-start'}>*/}
                                                {/*        Kampanya Avantajı*/}
                                                {/*    </Col>*/}
                                                {/*    <Col xs={12} lg={7} className={'data d-flex align-items-center justify-content-end'}>*/}
                                                {/*        <h6>50%</h6>*/}
                                                {/*    </Col>*/}
                                                {/*</Row>*/}
                                                <hr/>
                                                <Row>
                                                    <Col xs={'auto'}>
                                                        <img
                                                            alt={''}
                                                            src={info?.image ?? require('../../../assets/images/png/default-product.png')}
                                                            className={'img-thumbnail w-100 rounded'}
                                                        />
                                                    </Col>
                                                    {
                                                        info?.name && (
                                                            <Col xs={true} className={'d-flex align-items-center'}>
                                                                <span className={'large-font'}>{info?.name}</span>
                                                            </Col>
                                                        )
                                                    }
                                                    {
                                                        info?.description && (
                                                            <Col xs={12} className={'mt-3 mb-3'}>
                                                                <p>
                                                                    {info?.description}
                                                                </p>
                                                            </Col>
                                                        )
                                                    }
                                                </Row>
                                            </Col>
                                            <Col xs={12} className={"mt-3"}>
                                                {
                                                    productList?.length > 0 && (
                                                        <h6 className={'mb-4'}>Kampanyaya Dahil Ürünler</h6>
                                                    )
                                                }
                                                <Row className={"overflow-auto"} style={{maxHeight: [1, 2].includes(step) ? 300 : 'initial'}}>
                                                    <Col xs={12}>
                                                        {
                                                            productList?.map((v, i) => (
                                                                <Row className={'mb-3'}>
                                                                    <Col xs={'auto'} className={'d-flex h-100'}>
                                                                        <img
                                                                            alt={''}
                                                                            src={v?.image ?? require('../../../assets/images/png/default-product.png')}
                                                                            className={'img-thumbnail rounded'}
                                                                        />
                                                                    </Col>
                                                                    <Col xs={7} sm={8} className={'d-flex align-items-center justify-content-start h-100'}>
                                                                        {v?.name}
                                                                    </Col>
                                                                    <Col xs={'auto'} className={'d-flex align-items-center justify-content-center h-100'}>
                                                                        {v?.productSum}
                                                                    </Col>
                                                                </Row>
                                                            ))
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={'product-history mt-4'}>
                                <h3>Kampanya Geçmişi</h3>
                                <Row className={'mb-2'}>
                                    <Col xs={12} xxl={8}>
                                        <Row>
                                            <Col xs={12} md={'auto'} lg={6}>
                                                <div className={'table-box mb-lg-0 mb-3'}>
                                                    <span className={'table-box-title'}>UYGULANAN TOPLAM KAMPANYA İNDİRİM TUTARI</span><br/>
                                                    <span className={'table-box-value'}>{info?.totalPoints}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={'auto'} lg={6}>
                                                <div className={'table-box'}>
                                                    <span
                                                        className={'table-box-title'}>TOPLAM KATILIM SAYISI</span><br/>
                                                    <span className={'table-box-value'}>{info?.totalSellProducts}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Table
                                    columns={this.campaign_history_column}
                                    rowKey={(record) => (
                                        record?.transactionId ||
                                        record?.id ||
                                        record?.transactionDate ||
                                        record?.date ||
                                        record?.barcodeNo ||
                                        record?.productCode ||
                                        record?.productName
                                    )}
                                    dataSource={campaign_data}
                                    loading={loading}
                                    pagination={pagination}
                                    onChange={this.handleTableChange}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>

                {
                    modalOpen && step === 2 && (
                        <Modal
                            title={"Telefon numaranı doğrula"}
                            onCancel={() => {
                                this.setState({modalOpen: false, step: 1})
                            }}
                            visible={modalOpen}
                            footer={false}
                            className={"basket"}
                        >
                            <Form
                                layout={'vertical'}
                                initialValues={""}
                                onFinish={(e) => {
                                    return this.onFinishCampaingForm(e)
                                }}
                            >
                                <>
                                    <div className={'password-reset'}> {trans('t3')}
                                        <span className={'time'}>
                                            <Countdown
                                                precision={0}
                                                renderer={({minutes, seconds}) => (<span> {trans('t2', {minutes: zeroPad(minutes), seconds: zeroPad(seconds)})}</span>)}
                                                onComplete={() => this.setState({step: (step - 1),}, () => {
                                                    if (step === 3) {
                                                        HelperGeneral.alert('Doğrulama süresi sona erdi.')
                                                    }
                                                })}
                                                date={date}
                                            />
                                        </span>
                                    </div>
                                    <Form.Item
                                        name={'code'}
                                        rules={[() => ({
                                            validator(_, value) {
                                                const v = HelperGeneral.telephoneClear(value);
                                                if (v?.length === 6) {
                                                    return Promise.resolve()
                                                }
                                                return Promise.reject(new Error(trans('login.t22')))
                                            },
                                        })]}
                                        help={'Gönderilen 6 haneli onay kodunu giriniz.'}
                                    >
                                        <MaskedInput
                                            mask={'111111'}
                                            autoComplete={'new-password'}
                                            size={6}
                                        />
                                    </Form.Item>
                                </>

                                <hr/>
                                <Form.Item className={"d-flex justify-content-center text-center"}>
                                    <Button
                                        type="primary"
                                        className={'btn text-white btn-primary w-100'}
                                        style={{
                                            border: 'none',
                                            borderRadius: 3,
                                            height: 46,
                                        }}
                                        htmlType={'submit'}
                                    >
                                        Doğrula
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Modal>
                    )
                }
            </div>
        );
    }
}

export default withRouter(CampaignDetail);
